module.exports = __webpack_public_path__ + "files/7f2e921461965d93e10fbf914b7f74e7.svg";